import { useLocation, useNavigate } from 'react-router-dom';

export const useBackNavigate = (isPublic?: boolean) => {
  const location = useLocation();
  const navigate = useNavigate();

  return () => {
    const path = location.pathname;
    const paths = path.split('/');

    if (path.includes('/edit') || isPublic) {
      paths.pop();
      paths.pop();
    } else {
      paths.pop();
    }

    const backUrl = paths.join('/');
    navigate(backUrl, { replace: true });
  };
};
